<template>
    <div class="">
        <div class="tabs_content">
            <ul>
                <li class="active">帮助中心</li>
                <li @click="orderjump(2)">联系客服</li>
            </ul>
        </div>
        <div class="news_list_content" v-if="listshow">
            <ul>
                <li v-for="(item, index) in newslist" :key="index" @click="listClick(item.id)">
                    <div class="news_list_left">
                        <div class="news_list_title"><span>{{item.title}}</span></div>
                    </div>
                    <div class="news_list_right"><span>{{item.addtime}}</span></div>
                </li>
            </ul>
        </div>
        <noMsg v-if="notips"></noMsg>
        <Loadings v-if="loading"></Loadings>
        <!-- 分页 -->
        <div class="page_content" v-if="listshow">
            <Page
                :total="pagetotal"
                :current="pagecurrent"
                :page-size="pagesize"
                :page-size-opts="pagesizeopts"
                show-total
                show-sizer
                show-elevator
                @on-change="pageChange"
                @on-page-size-change="pageSizeChange" />
        </div>
    </div>
</template>

<script>
import api from '@/request/api.js'
import noMsg from '@/components/component/nomsg.vue'
import Loadings from '@/components/component/loading.vue'
export default {
    components: {noMsg, Loadings},
    data() {
        return {
            loading: false, // 加载中
            listshow: false, // 列表是否显示
            notips: false, // 暂无提示
            newslist: [], // 消息列表
            pagetotal: 0, // 分页总数
            pagesize: 30, // 分页每页条数
            pagesizeopts: [30, 60, 90], // 分页每页条数切换的配置[4, 8, 16][30, 60, 90]
            pagecurrent: 1, // 当前分页
        }
    },
    methods: {
        getInfo () { // 获取信息
            this.listshow = false
            this.notips = false
            this.loading = true
            this.http.post(api.help,
                {
                    page: this.pagecurrent,
                    pagesize: this.pagesize
                }
            )
            .then(response => {
                console.log(response.data.msg)
                this.newslist = response.data.msg.datalist
                this.pagetotal = response.data.msg.pagecontent.num
                this.loading = false
                response.data.msg.datalist.length > 0 ? this.listshow = true : this.notips = true
            })
            .catch(error => {
                console.log(error);
            })
        },
        orderjump (sign) { // 跳转页面
            let link
            if (sign == 1) {
                link = '/Help'
            } else {
                link = '/ContactService'
            }
            this.$router.push(link)
        },
        listClick (id) { // 点击列表
            this.$router.push({
                name: '帮助中心详情',
                params: {
                    id: id
                }
            })
        },
        pageChange (e) { // 分页翻页改变
            this.pagecurrent = e
            this.getInfo()
        },
        pageSizeChange (e) { // 分页每页条数改变
            this.pagecurrent = 1
            this.pagesize = e
            this.getInfo()
        },
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/help/help.vue